import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import ResetPassword from "./pages/ResetPassword";
import SunsetLake from "./pages/SunsetLake";

const STAKEHOLDER_PATHS = {
  "/universities": "universities",
  "/facilities": "facilities",
  "/health-systems": "facilities",
  "/pediatric-facilities": "pediatric",
  "/homecare-networks": "homecare",
  "/vocational-nursing": "lpn",
  "/global-usce": "img",
  "/preceptors": "preceptors",
};

function PathRedirect() {
  const { pathname } = useLocation();
  const track = STAKEHOLDER_PATHS[pathname.toLowerCase().replace(/\/+$/, "")];
  return <Navigate to={track ? `/?intake=${track}` : "/"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/sunset-lake" element={<SunsetLake />} />
          <Route path="*" element={<PathRedirect />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
